/* eslint-disable react/jsx-no-useless-fragment */
import { Ruler } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { IPostDetailResponse } from '@/redux/post/post.d';

function JobDetailsCard({ post }: { post: IPostDetailResponse }) {
  return post.toolSetter ||
    post.probeForZHeightCommand ||
    post.spindleSpeed ||
    post.jobSize ? (
    <Card>
      <CardHeader>
        <div className="flex gap-2 items-center">
          <Ruler className="h-5 w-5" />
          <CardTitle>Tool and Job Details</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-2 text-sm">
          {post.toolSetter ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Tool Setter:
              </dt>
              <dd>{post.toolSetter}</dd>
            </div>
          ) : (
            <></>
          )}
          {post.probeForZHeightCommand ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Probe Command:
              </dt>
              <dd>{post.probeForZHeightCommand}</dd>
            </div>
          ) : (
            <></>
          )}
          {post.spindleSpeed ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Spindle Speed:
              </dt>
              <dd>{post.spindleSpeed} RPM</dd>
            </div>
          ) : (
            <></>
          )}
          <Separator className="my-4" />
          {post.jobType ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Job Type:</dt>
              <dd>{post.jobType}</dd>
            </div>
          ) : (
            <></>
          )}
          {post.jobSize?.height ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Job Height:</dt>
              <dd>
                {post.jobSize.height} {post.units}
              </dd>
            </div>
          ) : (
            <></>
          )}
          {post.jobSize?.width ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Job Width:</dt>
              <dd>
                {post.jobSize.width} {post.units}
              </dd>
            </div>
          ) : (
            <></>
          )}
          {post.jobSize?.thickness ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Job Thickness:
              </dt>
              <dd>
                {post.jobSize.thickness} {post.units}
              </dd>
            </div>
          ) : (
            <></>
          )}
          {post.jobSize?.diameter ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">
                Job Diameter:
              </dt>
              <dd>
                {post.jobSize.diameter} {post.units}
              </dd>
            </div>
          ) : (
            <></>
          )}
          {post.jobSize?.length ? (
            <div className="grid grid-cols-2">
              <dt className="font-medium text-muted-foreground">Job Length:</dt>
              <dd>
                {post.jobSize.length} {post.units}
              </dd>
            </div>
          ) : (
            <></>
          )}
        </dl>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
}

export default JobDetailsCard;
